<template>
  <div>
    <h3 v-if="!isFilter" class="mt-3">Categorias</h3>
    <v-autocomplete
      v-model="productForms.departmentId"
      :items="departmentItems"
      item-text="name"
      item-value="id"
      label="Categoria nível 1"
      outlined
      color="#C3C8CD"
      height="44px"
      :disabled="!isFilter && !userHasPermission"
      :loading="isLoading"
      :search-input.sync="searchDepartment"
    />
    <v-autocomplete
      v-model="productForms.categoryId"
      :items="items"
      item-text="name"
      item-value="id"
      label="Categoria nível 2"
      outlined
      color="#C3C8CD"
      height="44px"
      :disabled="!productForms.departmentId || (!isFilter && !userHasPermission) || isLoading"
      :loading="isLoading"
      :search-input.sync="search"
      :error="validation && validation.product.categoryId && validation.product.categoryId.$error"
      :error-messages="categoryError"
    />
    <v-autocomplete
      v-if="!isFilter"
      v-model="productForms.subcategoryId"
      :items="subCategoryItems"
      item-text="name"
      item-value="id"
      label="Categoria nível 3"
      outlined
      color="#C3C8CD"
      height="44px"
      :disabled="!productForms.categoryId || (!isFilter && !userHasPermission) || isLoading"
      :search-input.sync="searchSubcategory"
    />
    <mf-button v-if="!isFilter" text :disabled="!productForms.departmentId" color="vermelho-d20" label="Limpar categorias" @click="clearCategories" />
  </div>
</template>

<script>
import { QUERY_GET_CATEGORIES, QUERY_GET_SUBCATEGORIES, QUERY_GET_DEPARTMENTS } from '@/modules/produtos/gerenciamento-produtos/graphql'

export default {
  name: 'SearchCategories',
  inject: ['userHasPermission'],
  props: {
    isFilter: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
    },
    validation: {
      type: Object,
      required: false,
    },
    ignoreMounted: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isLoading: false,
    isMounted: false,
    isCategoryMounted: false,
    search: '',
    searchSubcategory: '',
    searchDepartment: '',
    departmentsPagination: {
      page: 1,
      pageSize: 100000,
      search: '',
    },
    categoriesPagination: {
      page: 1,
      pageSize: 100000,
      search: '',
    },
    subCategoryPagination: {
      page: 1,
      pageSize: 100000,
      search: '',
    },
    items: [],
    subCategoryItems: [],
    departmentItems: [],
  }),
  computed: {
    productForms: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    categoryError() {
      if (this.validation && this.validation.product.categoryId && this.validation.product.categoryId.$error) return 'Campo obrigatório'
      return ''
    },
  },
  watch: {
    'productForms.categoryId': function (value) {
      if (value) {
        if (this.isCategoryMounted || this.ignoreMounted) {
          this.productForms.subcategoryId = ''
          this.searchSubcategory = ''
        } else {
          this.isCategoryMounted = true
        }

        this.getSubCategories(value)
      }
    },
    'productForms.departmentId': function (value) {
      if (value) {
        if (this.mounted || this.ignoreMounted) {
          this.productForms.categoryId = ''
          this.productForms.subcategoryId = ''
          this.search = ''
          this.searchSubcategory = ''
        } else {
          this.mounted = true
        }

        this.getCategories(value)
      }
    },
  },
  mounted() {
    this.getDepartments()
  },
  methods: {
    getCategories(departmentId) {
      this.isLoading = true

      const variables = {
        ...this.categoriesPagination,
      }

      if (departmentId) {
        variables.departmentId = departmentId
      }

      this.$apollo
        .query({
          query: QUERY_GET_CATEGORIES,
          variables,
          context: {
            uri: this.$microservicesUrls['fedGateway'],
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data: { listCategory } }) => {
          this.items = listCategory.categories

          if (this.productForms.categoryId) this.getSubCategories(this.productForms.categoryId)
        })
        .catch(() => {
          this.$snackbar({ message: 'Erro ao carregar as categorias', snackbarColor: 'error' })
        })
        .finally(() => (this.isLoading = false))
    },
    getSubCategories(categoryId) {
      this.isLoading = true

      this.$apollo
        .query({
          query: QUERY_GET_SUBCATEGORIES,
          variables: { ...this.subCategoryPagination, categoryId },
          context: {
            uri: this.$microservicesUrls['fedGateway'],
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data: { listSubCategory } }) => {
          this.subCategoryItems = listSubCategory.subCategories
        })
        .catch(() => {
          this.$snackbar({ message: 'Erro ao carregar as categorias', snackbarColor: 'error' })
        })
        .finally(() => (this.isLoading = false))
    },
    getDepartments() {
      this.isLoading = true

      this.$apollo
        .query({
          query: QUERY_GET_DEPARTMENTS,
          variables: { ...this.departmentsPagination },
          context: {
            uri: this.$microservicesUrls['fedGateway'],
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data: { listDepartment } }) => {
          this.departmentItems = listDepartment.departments

          if (this.productForms.departmentId) this.getCategories(this.productForms.departmentId)
        })
        .catch(() => {
          this.$snackbar({ message: 'Erro ao carregar as departamentos', snackbarColor: 'error' })
        })
        .finally(() => (this.isLoading = false))
    },
    clearCategories() {
      this.productForms.departmentId = ''
      this.productForms.categoryId = ''
      this.productForms.subcategoryId = ''
      this.search = ''
      this.searchSubcategory = ''
      this.searchDepartment = ''
    },
  },
}
</script>

<style lang="scss"></style>
